export default __webpack_public_path__ + "earth.b1d3fd20.glb";